export function lowerCaseString(value: string) {
  return value.toLowerCase()
}
export function upperCaseString(value: string) {
  return value.toUpperCase()
}

export function snakeCaseToCamelCase(s: string) {
  return s.replace(/(_\w)/g, m => m[1].toUpperCase())
}

export function camelCaseToSnakeCase(s: string) {
  return s.replace(/([a-z])([A-Z])/g, m => m[0] + '_' + m[1].toLowerCase())
}

export function buildId(preffix, ...parts) {
  const id = preffix ? [preffix].concat(parts).join('__') : null
  return id
}

export function digitsOnly(value: string) {
  return value.replace(/\D/g, '')
}
